import {
     BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell,
   } from "recharts";
   import {
     Card, Col, CardHeader, CardBody, Container, Button, Label,
     Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
   } from "reactstrap";
   import { useEffect, useState } from "react";
   import { format } from "date-fns";
   import ApiService from "../../services/apiService";
   import DateTimePicker from "react-datepicker";
   import LoadingComponent from "../lodingComponent";
   import Table from "../table/Table";
   import LeftIcon from "../svg/LeftButton";
   import RightIcon from "../svg/RightIcon";
   import { usePagination } from "../../hooks/usePagination";
import { newDate } from "react-datepicker/dist/date_utils";
import ExportExcel from "../reports/ExportExcel";
   
   const getWindowSize = () => (window.innerWidth <= 1440 ? 8 : 10);
   
   const CustomTooltip = ({ active, payload, label }: any) => {
     if (active && payload && payload.length) {
       return (
         <div style={{
           backgroundColor: "white", borderRadius: "6px",
           border: "1px solid #ddd", boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
           padding: "10px 14px", fontSize: "13px",
         }}>
           <p style={{ margin: 0, fontWeight: 600, marginBottom: 4 }}>{label}</p>
           <p style={{ margin: 0, color: "#2B5F60" }}>
             Water Distributed Under Wua: <strong>{payload[0].value}(m³)</strong>
           </p>
         </div>
       );
     }
     return null;
   };
   
   const CustomBarLabel = (props: any) => {
     const { x, y, width, value } = props;
     if (!value || value === 0) return null;
     return (
       <text x={x + width / 2} y={y - 6} fill="#444" textAnchor="middle" fontSize={12}>
         {value}
       </text>
     );
   };
   
   const WuaDashboard = () => {
     const endDate = new Date();
     const startDate = new Date();
     startDate.setDate(startDate.getDate() - 6);
     startDate.setHours(0, 0, 0, 0);
   
     const [wuas, setWuas] = useState<any[]>([]);
     const [selectedWuas, setSelectedWuas] = useState<any>();
     const [allWuaId, setAllWuaId] = useState<string | number>();
     const [dropdownOpen, setDropdownOpen] = useState(false);
     const [windowSize] = useState<number>(getWindowSize());
     const [chartStartIndex, setChartStartIndex] = useState(0);
     const [enabled, setEnabled] = useState(false);
     const [chartData, setChartData] = useState<any[]>([]);
     const [chartLoading, setChartLoading] = useState(false);
   
     const {
       data,
       loading,
       pageNumber,
       setPageNumber,
       totalCount,
       pageSize,
       fromDate,
       toDate,
       setFromDate,
       setToDate,
       setWauId,
       setRefresh,
       
     } = usePagination({
       endpoint: "/wuareport/getdistributionunderwua",
       pageSize: 10,
       enabled,
     });
   
     // ── Chart ke liye alag fetch (saara data, no pagination) ─────────────
     const fetchChartData = async (
       wuaId: string | number | undefined,
       from?: any,
       to?: any
     ) => {
       setChartLoading(true);
       try {
         const response = await ApiService.axiosApi(
           `/wuareport/getdistributionunderwua`,
           {
             method: "GET",
             params: {
               WuaId: wuaId,
               FromDate: from
                 ? format(new Date(from), "yyyy-MM-dd HH:mm:ss")
                 : format(startDate, "yyyy-MM-dd HH:mm:ss"),
               ToDate: to
                 ? format(new Date(to), "yyyy-MM-dd HH:mm:ss")
                 : format(endDate, "yyyy-MM-dd HH:mm:ss"),
               PageNumber: 1,
               PageSize: 0,  // ✅ saara data
             },
           }
         );
   
         if (response.success) {
           setChartData(response.data.data);
           setChartStartIndex(0);
         }
       } catch (e) {
         console.log("chart fetch error", e);
       } finally {
         setChartLoading(false);
       }
     };
     const fectWuaReport = async() => {
          try {
            const response = await ApiService.axiosApi(`/wuareport/getdistributionunderwua`, {
              method: 'GET',
              params: {
                WuaId: allWuaId,   // ✅ allWuaId use karo
                pageNumber: 0,
                pageSize: 0,
                FromDate: fromDate 
                  ? format(new Date(fromDate), 'yyyy-MM-dd HH:mm:ss') 
                  : format(startDate, 'yyyy-MM-dd HH:mm:ss'),   // ✅
                ToDate: toDate 
                  ? format(new Date(toDate), 'yyyy-MM-dd HH:mm:ss') 
                  : format(endDate, 'yyyy-MM-dd HH:mm:ss'),     // ✅
              }
            });
        
            if (response.success) {
              return response.data.data;
            } else {
              console.log("unable to get wua report");
            }
          } catch(e) {
            console.log(e);
          }
        }
     // ── WUAs fetch on mount ───────────────────────────────────────────────
     useEffect(() => {
       const init = async () => {
         try {
           const response = await ApiService.axiosApi(`/wua`, {
             method: "GET",
             params: { pageNumber: 0, pageSize: 0 },
           });
   
           if (response.success) {
             const wuaData = response.data.data;
             setWuas(wuaData);
   
             if (wuaData.length > 0) {
               const first = wuaData[0];
               setSelectedWuas(first.headQuaterName);
               setAllWuaId(first.id);
               setWauId(first.id);
               setEnabled(true);                         // table fetch start
               await fetchChartData(first.id);           // chart fetch
             }
           }
         } catch (e) {
           console.log("unable to get wua", e);
         }
       };
       init();
     }, []);
   
     const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
   
     // ── Chart windowing ───────────────────────────────────────────────────
     const visibleChartData = chartData.slice(
       chartStartIndex,
       chartStartIndex + windowSize
     );
   
     const handleChartNext = () => {
       if (chartStartIndex + windowSize < chartData.length)
         setChartStartIndex(chartStartIndex + windowSize);
     };
   
     const handleChartPrev = () => {
       if (chartStartIndex - windowSize >= 0)
         setChartStartIndex(chartStartIndex - windowSize);
     };
   
     // ── Generate button ───────────────────────────────────────────────────
     const handleGenerate = () => {
       fetchChartData(allWuaId, fromDate, toDate);  // ✅ chart — saara data
       setPageNumber(1);
       setRefresh((r: any) => !r);                  // ✅ table — page 1 se
     };
   
     return (
          <>
          <br />
       <Container fluid="true" style={{ height: "100%" }}>
   
         {/* ── Header ── */}
         <div className="dashboard-header px-2 mb-3" style={{ marginLeft: "1px" }}>
           <div className="d-flex justify-content-between  gap-3 py-2">
               <div>
             <h4 style={{ fontWeight: 700, margin: 0, whiteSpace: "nowrap" }}>
             WUA Dashboard 
             </h4>
             </div>
             <div className="d-flex">
             <div className="d-flex align-items-center gap-2 mx-2">
               {/* <Label style={{ margin: 0, fontWeight: 500, whiteSpace: "nowrap" }}>
                 Wuas:
               </Label> */}
               <Dropdown
                 isOpen={dropdownOpen}
                 toggle={toggleDropdown}
                 className="custom-dropdown-wrapper"
               >
                 <DropdownToggle
                   className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
                   style={{
                     fontWeight: 500, borderRadius: "6px",
                     padding: "6px 14px", width: "160px", height: "30px",
                   }}
                   color="whitesmoke"
                 >
                   {selectedWuas ?? "Select WUA"}
                 </DropdownToggle>
                 <DropdownMenu
                   className="custom-dropdown-menu"
                   style={{
                     overflowY: "auto", maxHeight: "220px",
                     boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.1)",
                     borderRadius: "8px", padding: "6px 0",
                   }}
                 >
                   {wuas?.map((w: any) => (
                     <DropdownItem
                       key={w.id}
                       onClick={() => {
                         setSelectedWuas(w.headQuaterName);
                         setAllWuaId(w.id);
                         setWauId(w.id);
                       }}
                     >
                       {w.headQuaterName}
                     </DropdownItem>
                   ))}
                 </DropdownMenu>
               </Dropdown>
             </div>
             <div className="report-input-div mx-2 input-border d-flex flex-column ">
             <DateTimePicker
               className="dashboard-input"
               dateFormat="dd/MM/yyyy HH:mm:ss"
               placeholderText="From Date"
               showTimeSelect
               onChange={(date: any) => setFromDate(date)}
               selected={fromDate ?? startDate}
               isClearable
               timeFormat="HH:mm:ss"
             />
          </div>
          <div className="report-input-div mx-2 input-border d-flex flex-column ">
             <DateTimePicker
               className="dashboard-input"
               dateFormat="dd/MM/yyyy HH:mm:ss"
               placeholderText="To Date"
               showTimeSelect
               onChange={(date: any) => setToDate(date)}
               selected={toDate ?? endDate}
               isClearable
               timeFormat="HH:mm:ss"
             />
          </div>
          <div>
             <Button
               color="success"
               className="button-dashboard mx-2 px-1 py-1"
             
               onClick={handleGenerate}
             >
               Generate
             </Button>
             </div>


           
             </div>
           </div>
         </div>
   
         {/* ── Bar Chart ── */}
         <Col style={{ height: "100%" }}>
           <Card
             className="m-0 b-r-0"
           
           >
             <CardHeader
              
             >
               <div className="d-flex justify-content-between align-items-start">
                 <div className="d-flex flex-column">
                   <h5 style={{ fontWeight: 700, margin: 0 }}>Water Distribution Under WUA</h5>
                   <p style={{ fontSize: "12px", color: "#888", margin: "4px 0 0" }}>
                     {fromDate
                       ? format(new Date(fromDate), "dd/MM/yyyy")
                       : format(startDate, "dd/MM/yyyy")}
                     {" – "}
                     {toDate
                       ? format(new Date(toDate), "dd/MM/yyyy")
                       : format(endDate, "dd/MM/yyyy")}
                     {selectedWuas && (
                       <span style={{ marginLeft: 8, color: "#2B5F60", fontWeight: 600 }}>
                         · {selectedWuas}
                       </span>
                     )}
                   </p>
                 </div>
   
                 {/* Chart arrows */}
                 <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                   <button
                     className="icon-button"
                     onClick={handleChartPrev}
                     disabled={chartStartIndex === 0}
                   >
                     <LeftIcon />
                   </button>
                   <button
                     className="icon-button"
                     onClick={handleChartNext}
                     disabled={chartStartIndex + windowSize >= chartData.length}
                   >
                     <RightIcon />
                   </button>
                 </div>
               </div>
             </CardHeader>
   
             <CardBody style={{ padding: "20px" }}>
               {chartLoading ? (
                 <LoadingComponent />
               ) : (
                 <ResponsiveContainer width="100%" height={300}>
                   <BarChart data={visibleChartData} barCategoryGap="20%" barGap={2}>
                     <XAxis
                       dataKey="dateTime"
                       padding={{ left: 5, right: 5 }}
                       tick={{ fontSize: 15 ,textAnchor: 'end' }}
                       tickMargin={8}
                       interval={0}
                       angle={-20}  
                       height={50}
                       tickFormatter={(value) =>
                         new Date(value).toLocaleDateString("en-GB", {
                           day: "2-digit",
                           month: "short",
                           year: "numeric",
                         })
                       }
                     />
                     <YAxis
                       tick={{ fontSize: 12, fill: "#444" }}
                       domain={[0, "auto"]}
                       axisLine={{ stroke: "#ccc" }}
                       tickLine={{ stroke: "#ccc" }}

                       label={{
                        value: "Volume (m³)",
                        angle: -90,
                        position: "insideRight",
                        dx: -40,
                        dy:-43
                      }}
                     />
                     <Tooltip
                       content={<CustomTooltip />}
                       cursor={{ fill: "rgba(43,95,96,0.06)" }}
                     />
                     <Bar
                       dataKey="totalWaterDistrubuted"
                       animationDuration={600}
                       label={<CustomBarLabel />}
                       radius={[4, 4, 0, 0]}
                       barSize={32}
                       fill="#2B5F60"
                     >
                       {visibleChartData?.map((_: any, i: number) => (
                         <Cell key={`cell-${i}`} />
                       ))}
                     </Bar>
                   </BarChart>
                 </ResponsiveContainer>
               )}
             </CardBody>
           </Card>
         </Col>
   
         <br />
   
         {/* ── Table ── */}
         <Card className="wua-dashboard-table mb-2 b-r-0">
         <div className="d-flex justify-content-end px-2 pt-2 mb-1">
        <div style={{ width: '130px' }}>
          <ExportExcel
            getData={fectWuaReport}
            toDate={toDate ? format(new Date(toDate), 'dd/MM/yyyy HH:mm:ss') : format(endDate, 'dd/MM/yyyy HH:mm:ss')}
            fileName='Water_Distribution_Under_WuaReport'
            EffectiveFrom={fromDate ? format(new Date(fromDate), 'dd/MM/yyyy HH:mm:ss') : format(startDate, 'dd/MM/yyyy HH:mm:ss')}
            selectedChakScheme={selectedWuas}
            columnHeaderMap={{
              dateTime: 'DateTime',
              totalWaterDistrubuted: 'Total Water Distrubuted',
            }}
            columnOrder={['dateTime', 'totalWaterDistrubuted']}
          />
        </div>
      </div>

           {loading ? (
             <LoadingComponent />
           ) : (
             <>
               <Table
                 data={data}
                 isAction={false}
                 columns={[
                   { header: "DateTime", accessor: "dateTime" },
                   { header: "Total Water Distributed(m³)", accessor: "totalWaterDistrubuted" },
                 ]}
                 buttons={[]}
               />
   
               {/* Table pagination */}
               <div className="d-flex justify-content-end align-items-center mt-2 px-1">
                 <span style={{ fontSize: "13px", color: "#666" }}>
                 Page {pageNumber} of {Math.ceil(totalCount / pageSize)}
                  
                 </span>
                 <div className="d-flex gap-2">
                   <button
                     className="icon-button"
                     onClick={() => setPageNumber((p: number) => p - 1)}
                     disabled={pageNumber === 1}
                   >
                     <LeftIcon />
                   </button>
                   <button
                     className="icon-button"
                     onClick={() => setPageNumber((p: number) => p + 1)}
                     disabled={pageNumber >= Math.ceil(totalCount / pageSize)}
                   >
                     <RightIcon />
                   </button>
                 </div>
               </div>
             </>
           )}
         </Card>
   
       </Container>
       </>
     );
   };
   
   export default WuaDashboard;